/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Text as ThemeUIText } from 'theme-ui';
import React, { forwardRef } from 'react';

import type { ComponentProps } from 'react';
import type {
  ThemeUIStyleObject,
  TextProps as ThemeUITextProps,
} from 'theme-ui';
import type { ThemeUIComponent } from './theme-ui';

/**
 * Primitive typographic component.
 *
 * Text style variants can be defined in the theme.text object.
 * @see https://theme-ui.com/components/text
 */
export const Text = forwardRef(
  (props: ThemeUITextProps & { sx?: ThemeUIStyleObject }, ref) => (
    <ThemeUIText {...props} as={props.as ?? 'div'} ref={ref} />
  ),
) as ThemeUIComponent<'text', 'div', ThemeUITextProps>;

export type TextProps = ComponentProps<typeof Text>;

Text.displayName = 'Text';
